import { FavoritesReducerStateShape, favoritesReducerPath } from '@cp/entities/client';
import { EntityId } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';

export const useFavorites = (): EntityId[] => useSelector((state: FavoritesReducerStateShape) => state[favoritesReducerPath]) || [];
